<div class="tw-flex tw-flex-col tw-gap-2">
  <!-- Account Display Template -->
  <ng-template #accountDisplayTemplate let-data="data">
    <div class="sm:tw-flex sm:tw-flex-col">
      <span class="tw-text-[12px] tw-font-medium tw-text-neutral-600">
        {{ "opening" | i18n }}:
        {{ _mOpeningBalances.get(data.id)?.balanceForm?.balance | currency: data.currency }}
      </span>
      <span
        *ngIf="_mClosingBalances.get(data.id)"
        class="tw-text-[12px] tw-font-medium tw-text-neutral-600"
      >
        {{ "closing" | i18n }}:
        {{ _mClosingBalances.get(data.id)?.balanceForm?.balance | currency: data.currency }}
      </span>
    </div>
  </ng-template>

  <!-- Linked Accounts Display -->
  <div *ngIf="linkedAccounts.length > 0" class="tw-flex tw-flex-col tw-gap-2">
    <span class="tw-font-medium">{{ "linkedCabinetAccounts" | i18n }} *</span>
    <app-item-display
      *ngFor="let linkedAccount of linkedAccountsDisplay"
      [item]="linkedAccount"
      (editFunction)="receivedEditAccount($event)"
      (removeFunction)="receivedRemoveAccount($event)"
    >
      <ng-container
        *ngTemplateOutlet="accountDisplayTemplate; context: { data: linkedAccount.templateData }"
      ></ng-container>
    </app-item-display>
  </div>

  <!-- Statement Account Selection -->
  <div
    class="tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-bg-neutral-50 tw-border tw-p-4"
    [ngClass]="{
      'tw-border-danger': noLinkedAccountErrorText,
      'tw-border-neutral-100': !noLinkedAccountErrorText,
    }"
  >
    <!-- Header -->
    <div class="tw-flex tw-justify-between tw-items-center">
      <span class="tw-font-medium tw-whitespace-nowrap">{{ "statementAccount" | i18n }} *</span>
    </div>

    <!-- Account Dropdown -->
    <app-dropdown-select
      [placeholder]="'selectExistingAccount' | i18n"
      [selectedOption]="accountInAction?.name"
      [options]="accountNamesList"
      [disabledOptions]="disabledOptions"
      (optionSelected)="accountSelected($event)"
    ></app-dropdown-select>

    <!-- Statement Balance Section (only shown when account is selected) -->
    <div *ngIf="accountInAction" class="tw-flex tw-w-full tw-flex-col tw-gap-2">
      <span class="tw-font-medium">{{ "statementBalance" | i18n }} *</span>

      <div class="tw-flex tw-w-full tw-gap-4">
        <!-- Opening Balance Input -->
        <div class="tw-w-1/2 tw-flex tw-flex-col tw-gap-1">
          <!-- Mobile-only label above the box (aligned with "Statement Balance") -->
          <span class="tw-hidden sm:tw-block tw-text-sm tw-font-medium">{{
            "opening" | i18n
          }}</span>
          <label
            class="left-round-border tw-flex tw-cursor-text tw-items-center tw-gap-3 tw-bg-color-surface-input tw-px-6 tw-py-3 tw-shadow-elevation-input"
            [ngClass]="{ 'tw-border tw-border-solid tw-border-danger': openingBalanceErrorText }"
          >
            <span class="tw-text-sm sm:tw-hidden">{{ "opening" | i18n }}</span>
            <input
              #openingBalanceInput
              (input)="openingBalanceChange($event)"
              [value]="addBalanceFormGroup.get('openingBalance').value"
              type="number"
              placeholder="0.00"
              class="tw-w-full tw-border-0 tw-bg-transparent tw-text-left focus:tw-outline-none"
            />
            <span class="tw-uppercase tw-text-neutral-300">{{ currentCurrency }}</span>
          </label>
          <span *ngIf="openingBalanceErrorText" class="tw-text-danger tw-text-sm">
            {{ openingBalanceErrorText | i18n }}
          </span>
        </div>

        <!-- Closing Balance Input -->
        <div class="tw-w-1/2 tw-flex tw-flex-col tw-gap-1">
          <!-- Mobile-only label above the box (aligned with "Statement Balance") -->
          <span class="tw-hidden sm:tw-block tw-text-sm tw-font-medium">{{
            "closing" | i18n
          }}</span>
          <label
            class="right-round-border tw-flex tw-cursor-text tw-items-center tw-gap-3 tw-bg-color-surface-input tw-px-6 tw-py-3 tw-shadow-elevation-input"
            [ngClass]="{ 'tw-border tw-border-solid tw-border-danger': closingBalanceErrorText }"
          >
            <span class="tw-text-sm sm:tw-hidden">{{ "closing" | i18n }}</span>
            <input
              #closingBalanceInput
              (input)="closingBalanceChange($event)"
              [value]="addBalanceFormGroup.get('closingBalance').value"
              type="number"
              placeholder="0.00"
              class="tw-w-full tw-border-0 tw-bg-transparent tw-text-left focus:tw-outline-none"
            />
            <span class="tw-uppercase tw-text-neutral-300">{{ currentCurrency }}</span>
          </label>
          <span *ngIf="closingBalanceErrorText" class="tw-text-danger tw-text-sm">
            {{ closingBalanceErrorText | i18n }}
          </span>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <span *ngIf="noLinkedAccountErrorText" class="tw-text-danger tw-text-sm">
      {{ noLinkedAccountErrorText | i18n }}
    </span>
  </div>

  <div *ngIf="accountInAction" class="tw-w-full tw-flex tw-justify-end">
    <div
      class="tw-rounded-xl hover:tw-bg-tealgray-100 tw-p-1 tw-cursor-pointer tw-max-w-[209px]"
      (click)="linkSelectedAccount()"
    >
      <div
        class="tw-rounded-lg tw-bg-white tw-border-teal-100 tw-border tw-flex tw-justify-center tw-items-center tw-px-6 tw-py-2 tw-gap-2"
      >
        <span class="tw-whitespace-nowrap tw-pointer-events-none">
          {{ "linkAccount" | i18n }}
        </span>
        <icon [name]="'add'" [size]="5" [currentColor]="'primary'"></icon>
      </div>
    </div>
  </div>
</div>
